import S from "./styles.module.scss";

interface PageLoaderProps {
  fullscreen?: boolean;
}

const PageLoader = ({ fullscreen = true }: PageLoaderProps) => (
  <div
    className={`${S.wrap} ${fullscreen ? S.fullscreen : S.inline}`}
    role="status"
    aria-label="Carregando"
  >
    <span className={S.loader} aria-hidden="true" />
  </div>
);

export default PageLoader;

